import React from 'react';
import { ChevronDown, Car, Zap } from 'lucide-react';
import { Button } from '../ui/button';
import { heroData } from '../../data/mock-v2';

const HeroV2 = () => {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image - Ciudad moderna con fuente (fondo claro) */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.image}
          alt="LUCARS Ciudad Moderna"
          className="w-full h-full object-cover"
        />
        {/* Overlay muy sutil */}
        <div className="absolute inset-0 bg-blue-50/40"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-20 text-center">
        <div className="max-w-6xl mx-auto space-y-8 pt-20">
          {/* Logo LUCARS Grande con fondo blanco y borde verde */}
          <div className="space-y-6 animate-fadeIn">
            <div className="flex justify-center">
              <div className="bg-gradient-to-br from-white to-gray-50 backdrop-blur-md rounded-3xl px-16 py-12 shadow-2xl border-4 border-[#63E61E] ring-4 ring-[#63E61E]/20">
                <img 
                  src="https://customer-assets.emergentagent.com/job_responsive-design-68/artifacts/pi8nnphe_LUCARS_LOGO.png" 
                  alt="LUCARS - Siempre en Movimiento" 
                  className="h-64 md:h-80 lg:h-96 w-auto object-contain"
                />
              </div>
            </div>
          </div>

          {/* Description */}
          <p className="text-xl md:text-2xl lg:text-3xl text-gray-900 max-w-4xl mx-auto leading-relaxed font-semibold bg-gradient-to-r from-white/95 to-gray-50/95 py-6 px-8 rounded-2xl shadow-lg border border-gray-200">
            {heroData.description}
          </p>

          {/* Features Grid - Solo 2 tarjetas con estilo diferente */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto pt-8">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 backdrop-blur-md rounded-2xl p-8 border-2 border-gray-700 hover:border-[#63E61E] transition-all duration-300 hover:scale-105 shadow-xl">
              <Car className="w-12 h-12 text-white mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-3">Autos a Gasolina</h3>
              <p className="text-gray-300 text-base">Vehículos confiables y eficientes</p>
            </div>
            <div className="bg-gradient-to-br from-[#63E61E] to-[#52c518] backdrop-blur-md rounded-2xl p-8 border-2 border-[#63E61E] hover:border-gray-900 transition-all duration-300 hover:scale-105 shadow-xl">
              <Zap className="w-12 h-12 text-gray-900 mx-auto mb-4" />
              <h3 className="text-gray-900 font-bold text-xl mb-3">Autos Eléctricos</h3>
              <p className="text-gray-900 text-base">Tecnología limpia y sustentable</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button
              onClick={scrollToAbout}
              className="bg-gradient-to-r from-[#63E61E] to-[#52c518] hover:from-[#52c518] hover:to-[#63E61E] text-gray-900 font-bold text-lg px-10 py-7 rounded-full transition-all duration-300 shadow-2xl hover:shadow-[#63E61E]/50 hover:scale-105"
            >
              Conocer Más
            </Button>
            <Button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gray-900 hover:bg-gray-800 text-white font-bold text-lg px-10 py-7 rounded-full transition-all duration-300 shadow-xl border-2 border-gray-900"
            >
              Contáctanos
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-10 h-10 text-[#63E61E]" />
        </div>
      </div>
    </section>
  );
};

export default HeroV2;
